import { Badge } from '@shared/components/ui/badge';
import { Button } from '@shared/components/ui/button';
import { Shop } from '@shared/components/ui/shop';
import { IncidentMapping } from '../../models/Mapping';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-light-svg-icons';

interface CardProps {
  mapping: IncidentMapping;
  onEdit?: (mapping: IncidentMapping) => void;
  couriersMap?: Map<number, { id: number; name: string; image_hash?: string | null }>;
}

export const Card = ({ mapping, onEdit, couriersMap }: CardProps) => {
  const courier = mapping.courier || couriersMap?.get(Number(mapping.courier_id)) || null;

  const statusBadge =
    mapping.status === 'mapped'
      ? { text: 'Mapeado', cls: 'bg-card-border text-badge-status-3' }
      : { text: 'Sin mapear', cls: 'bg-card-border text-badge-status-1' };

  return (
    <div className="py-5 border-b border-card-border">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-1">
          <div className="text-sm font-semibold">Mapping #{mapping.id ?? '-'}</div>
          <div className="flex items-center gap-2">
            <Badge className={`text-xs ${statusBadge.cls}`}>{statusBadge.text}</Badge>
            {courier && (
              <div className="ml-auto">
                <Shop name={courier.name} src={courier.image_hash || undefined} />
              </div>
            )}
          </div>
        </div>
        <Button size="icon" variant="ghost" className="w-9 h-9" onClick={() => onEdit?.(mapping)} title="Editar">
          <FontAwesomeIcon icon={faPen} className="w-3.5 h-3.5" />
        </Button>
      </div>

      {/* Tipos */}
      <div className="grid grid-cols-2 gap-3 mt-3 text-sm">
        <div className="space-y-1">
          <div className="text-xs text-complementary-text">Tipo externo</div>
          <div className="font-medium">
            {mapping.courier_incident_kind?.external_label || mapping.courier_incident_kind?.external_code || '-'}
          </div>
          {mapping.courier_incident_kind?.external_code && (
            <Badge variant="outline" className="w-fit text-[10px] leading-none !py-1 bg-card-border text-text">
              {mapping.courier_incident_kind.external_code}
            </Badge>
          )}
        </div>
        <div className="space-y-1">
          <div className="text-xs text-complementary-text">Tipo interno</div>
          <div className="font-medium">
            {mapping.incident_type?.label || mapping.incident_type?.name || 'Sin mapear'}
          </div>
          {mapping.incident_type?.code && (
            <Badge variant="outline" className="w-fit text-[10px] leading-none !py-1 bg-card-border text-text">
              {mapping.incident_type.code}
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};
